import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';
import { LayerTypeFilter } from '../../../../configuration/model/LayerTypeFilter';
import { MapThemeEditorComponent } from '../../map-theme-editor/map-theme-editor.component';

export class AssignmentStatusConfig {
    threshold: number;
    defaultLegendSettings: LayerTypeFilter;
    legendSettings: LayerTypeFilter;
}

@Component({
  selector: 'app-assignment-status-map-config',
  templateUrl: './assignment-status-map-config.component.html',
  styleUrl: './assignment-status-map-config.component.scss',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatDialogContent,
    MatSlider,
    MatSliderThumb,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MapThemeEditorComponent,
  ],
})
export class AssignmentStatusMapConfigComponent implements OnInit {
  thresholdIndex: number;
  thresholdValues: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 21, 24, 30, 36, 48, 72];

  constructor(
    public dialogRef: MatDialogRef<AssignmentStatusMapConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AssignmentStatusConfig
  ) {}

  ngOnInit() {
    this.thresholdIndex = this.thresholdValues.indexOf(this.data.threshold) + 1;
  }

  // we do not have access to component members here, so we pass it via parameter
  formatLabel(values: number[]) {
    return (index: number): string => {
      return `${values[index - 1]}h`;
    };
  }

  onThresholdChange(e) {
    this.data.threshold = this.thresholdValues[this.thresholdIndex - 1];
  }

  reset() {
    this.data.threshold = 4;
    this.thresholdIndex = this.thresholdValues.indexOf(this.data.threshold) + 1;

    const serviced = this.data.legendSettings.measurementUnits.find(i => i.number === 'Serviced');
    const defaultServiced = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Serviced');
    if (serviced && defaultServiced) {
      serviced.color = defaultServiced.color;
      serviced.dashArray = defaultServiced.dashArray;
    }

    const inProgress = this.data.legendSettings.measurementUnits.find(i => i.number === 'In Progress');
    const defaultInProgress = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'In Progress');
    if (inProgress && defaultInProgress) {
      inProgress.color = defaultInProgress.color;
      inProgress.dashArray = defaultInProgress.dashArray;
    }

    const notServiced = this.data.legendSettings.measurementUnits.find(i => i.number === 'Not Serviced');
    const defaultNotServiced = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Not Serviced');
    if (notServiced && defaultNotServiced) {
      notServiced.color = defaultNotServiced.color;
      notServiced.dashArray = defaultNotServiced.dashArray;
    }
  }

  isDefault() {
    return this.data.threshold === 4 &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Serviced')?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === 'Serviced')?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Serviced')?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === 'Serviced')?.dashArray &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'In Progress')?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === 'In Progress')?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'In Progress')?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === 'In Progress')?.dashArray &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Not Serviced')?.color ===
      this.data.legendSettings.measurementUnits.find(i => i.number === 'Not Serviced')?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Not Serviced')?.dashArray ===
      this.data.legendSettings.measurementUnits.find(i => i.number === 'Not Serviced')?.dashArray;
  }
}
